__turbopack_context__.v({
  "exhibitionCard": "exhibition-card-module-scss-module__Tm8WZW__exhibitionCard",
  "figure": "exhibition-card-module-scss-module__Tm8WZW__figure",
  "image": "exhibition-card-module-scss-module__Tm8WZW__image",
  "meta": "exhibition-card-module-scss-module__Tm8WZW__meta",
  "status": "exhibition-card-module-scss-module__Tm8WZW__status",
  "title": "exhibition-card-module-scss-module__Tm8WZW__title",
});
